import React from 'react';
import { InlineLoader } from '../../../components/Loader';
import { useErrorLogger } from '../../../hooks/useErrorLogger';
import { useOrgById } from '../../services/orgs';

export const OrgNameLazy = ({ orgId }: { orgId: string }) => {
  const [org, loading, error] = useOrgById(orgId);
  useErrorLogger('orgNameLazy', error);
  if (error) {
    return <span>Error</span>;
  }
  if (loading) {
    return <InlineLoader />;
  }
  if (!org) {
    return <span>Not found</span>;
  }
  return <span>{org.data.name}</span>;
};
